<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-12 px-1" v-if="statusSnack.snack">
        <v-snackbar v-model="statusSnack.snack" :timeout="snackTimeout" :color="statusSnack.snackColor">
          {{ statusSnack.snackText }}
          <v-btn text @click="resetStatusSnack()">Close</v-btn>
        </v-snackbar>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-12">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Appointment Details</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2">Choose Appointment Time</v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 3" step="3">Choose Appointment Format</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4">Confirm Appointment</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="py-5">
                <v-row>
                  <v-col cols="12" sm="8">
                    <p>
                      To schedule an appointment, please enter pin below. Your
                      primary advisor is listed first.
                    </p>
                    <v-text-field v-model="searchAdvisorPin" @blur="getAdvisor()" outlined label="Enter PIN">
                    </v-text-field>
                    <v-card outlined color="lime lighten-4" v-if="Object.keys(advisorPreference).length > 0">
                      <v-card-subtitle>Scheduling information</v-card-subtitle>
                      <v-card-text>
                        <!-- {{advisorPreference.scheduling_information}} -->
                        <div v-html="`${advisorPreference.advising_additional_details}`" />

                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8">
                    <v-select v-model="selectedDuration" :items="durations" label="Select appointment length" outlined>
                      <template slot="selection" slot-scope="data">{{ data.item }} Minutes</template>
                      <template slot="item" slot-scope="data">{{ data.item }} Minutes</template>
                    </v-select>
                  </v-col>
                </v-row>

                <v-card-actions class="mt-12 py-5">
                  <v-btn text>Back</v-btn>
                  <v-divider></v-divider>
                  <v-btn color="primary" @click="displayCalendar()">Next</v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="py-5">
                <v-row class="fill-height">
                  <v-col>
                    <v-sheet height="85">
                      <v-toolbar flat color="white">

                        <div class="legend_office"></div>
                        <div class="legend_text_container">
                          <p class="legend_text">
                            In Person, Phone, or Zoom appointments available
                          </p>
                        </div>
                        <div class="legend_home"></div>
                        <div class="legend_text_container">
                          <p class="legend_text">
                            Phone or Zoom appointments only
                          </p>
                        </div>
                      </v-toolbar>
                    </v-sheet>

                    <v-sheet height="60">
                      <v-toolbar flat color="white">
                        <v-btn color="primary" @click="prev">
                          <v-icon small>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title class="legend_text">{{ title }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-sheet class="pa-0">
                          <v-switch v-model="show_full_cal" :value="true" :label="`Show full calendar`"
                            class="my-switch"></v-switch>
                        </v-sheet>
                        <v-divider></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="next">
                          <v-icon small>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-toolbar>
                    </v-sheet>


                    <div class="outter-calendar-container">
                      <div class="inner-calendar-container">
                      <v-calendar ref="calendar" v-model="focus" color="dark" :events="events"
                        :event-color="getEventColor" :event-height="35" :event-margin-bottom="2" :now="today"
                        :type="type" :weekdays="weekday" :first-interval="show_full_cal ? 0 : 7" :interval-minutes="60"
                        :interval-count="show_full_cal ? 24 :17" :short-intervals="false" @click:event="showEvent"
                        @click:date="viewDay" @change="updateRange"></v-calendar>
                 </div>
                 </div>
                  </v-col>
                </v-row>
                <v-card-actions class="mt-12 py-5">
                  <v-btn color="light" @click="e1 = 1">Back</v-btn>
                  <v-divider></v-divider>
                  <v-btn color="primary" @click="displayFormatpage()">Next</v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="py-5">
                <v-row>
                  <v-col cols="12" sm="8">
                    <p>
                      To schedule an appointment, please select location.
                    </p>
                    <v-select v-model="selectedLocation" :items="locations" item-text="option" item-value="value"
                      label="Select the format of your advising appointment" outlined></v-select>
                  </v-col>
                </v-row>
                <v-card-actions class="mt-12 py-5">
                  <v-btn color="light" @click="e1 = 2">Back</v-btn>
                  <v-divider></v-divider>
                  <v-btn color="primary" @click="displayConfirmationPage()">Next</v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card class="py-5" v-if="selectedAdvisor">
                <v-card-text class="mb-3" style="background: lightgrey">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-label class="mr-3">Who: </v-label>
                      <v-label v-if="selectedAdvisor">
                        Appointment with
                        {{
                        `${selectedAdvisor.advsr_pers_fname} ${selectedAdvisor.advsr_pers_lname}`
                        }}</v-label>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-label class="mr-3">When: </v-label>
                      <v-label>
                        {{
                        generateHumanReadableTime(
                        selectedEvent.start,
                        selectedEvent.end
                        )
                        }}</v-label>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-label class="mr-3">Why: </v-label>
                      <v-label> Advising</v-label>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-label class="mr-3">Where: </v-label>
                      <v-label> {{ capitalize(selectedLocation) }}</v-label>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text class="mb-3" style="background: lightgrey">
                  <v-row>
                    <v-col cols="12" sm="8">
                      <h5>Additional Details</h5>
                      <!-- <p>{{ advisorPreference.advising_additional_details }}</p> -->
                      <div v-html="`${advisorPreference.scheduling_information}`" />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text class="mb-3" style="
                    box-shadow: inset 0.2px 0.2px 0 1px rgba(0, 0, 0, 0.12);
                  ">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <p>
                        Please list the reason for the appointment and any
                        topics you'd like to discuss with your advisor.
                      </p>
                      <v-textarea v-model="studentComment" outlined label="Appointment Information"></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field v-model="studentContact" outlined
                        label="Please enter a phone number where you may be reached"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text class="mb-3" style="background: lightgrey">
                  <v-row>
                    <v-col cols="12" sm="8">
                      <h5>Note</h5>
                      <p>Once you click the Confirm Appointment button, a calendar invitation will be
                        sent to your <a target="_blank" href="https://outlook.office.com/"><strong>UIS
                            email</strong></a> with the appointment details. If you would like to set up
                        your UIS email and calendar on your phone, please see this Knowledge Base
                        article: <a target="_blank" href="https://go.uis.edu/o365emailmobile">
                          https://go.uis.edu/o365emailmobile</a></p>

                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="mt-12 py-5">
                  <v-btn color="light" @click="e1 = 2">Back</v-btn>
                  <v-divider></v-divider>
                  <v-btn color="primary" :disabled="confirmBtnState" @click="confirmExternalAppointment()">Confirm Appointment
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
  </div>
</template>
<style>
@import './scheduler.scss';
</style>

<script>
  import SchedulerScript from './scheduler.js'

  export default {
      name: 'Scheduler',
      mixins: [ SchedulerScript ],
  }
</script>
